<template>
    <div class="h-screen w-screen flex items-center justify-center p-12">
        <div>
            <h1 class="text-4xl font-bold text-gray-800">Uppsss... 😬</h1>
            <p class="text-gray-500 mt-5 mb-10">Die aufgerufenen Seite existiert leider nicht.</p>
            <router-link to="/" class="text-primary-default hover:underline hover:text-primary-hover">Zurück zur Startseite</router-link>
        </div>
    </div>
</template>